import { eflowApi } from "../../lib/api";
export const getAssetsChargingOptions = async (assets, projectId, chargeFilter) => {
    const requestBody = {
        assets,
        projectId
    };
    const { data } = await eflowApi.post(`/assets/chargeOptions${chargeFilter ? `?chargeUpto=${chargeFilter}` : ""}`, requestBody);
    return data;
};
export const getFutureChargingOptions = async (requestBody, chargeUpto) => {
    const { data } = await eflowApi.post(`/assets/chargeOptions/future?chargeUpto=${chargeUpto}`, requestBody);
    return data;
};
export const updateOrDeactivateChargerLink = async (requestBody) => {
    const { data } = await eflowApi.put("/assets/chargerLinks", requestBody);
    return data;
};
export const patchChargerLink = async (requestBody) => {
    const { data } = await eflowApi.patch("/assets/chargers/links", requestBody);
    return data;
};
